<template>
        <div :class="shown ? 'show' : 'hide'">
            <h2><b style="font-size:12rem">{{bold}}</b></h2>
            <h2 style="font-size:12rem; font-weight: 600" class="pt-5 mt-5">{{normal}}</h2>
        </div>
</template>

<script>
export default {
  components: {
  },
  props: [
    "shown", "bold", "normal"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
  .hide {
    display: none
  }
</style>